(() => {
  const selector = '[data-sd-variant-price-select]';

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((select) => {
      if (select.dataset.sdVariantPriceReady === 'true') return;

      select.dataset.sdVariantPriceReady = 'true';
      let requestSequence = 0;
      let requestController;

      select.addEventListener('change', async () => {
        const sectionId = select.dataset.section;
        const productUrl = select.dataset.productUrl;
        const variantId = select.value;
        const priceDestination = document.getElementById(`price-${sectionId}`);
        const pricingPanel = select.closest('.product__info-container')?.querySelector('.sd-pack-pricing');

        pricingPanel?.querySelectorAll('[data-variant-id]').forEach((row) => {
          const isSelected = row.dataset.variantId === variantId;
          row.classList.toggle('is-selected', isSelected);
          if (isSelected) {
            row.setAttribute('aria-current', 'true');
          } else {
            row.removeAttribute('aria-current');
          }
        });

        if (!sectionId || !productUrl || !variantId || !priceDestination) return;

        requestSequence += 1;
        const currentRequest = requestSequence;
        requestController?.abort();
        requestController = new AbortController();
        priceDestination.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(
            `${productUrl}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`,
            { signal: requestController.signal },
          );

          if (!response.ok) throw new Error(`Variant price request failed: ${response.status}`);

          const responseText = await response.text();
          if (currentRequest !== requestSequence) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const priceSource = html.getElementById(`price-${sectionId}`);

          if (!priceSource) throw new Error('Variant price markup was not returned');

          priceDestination.innerHTML = priceSource.innerHTML;
          window.history.replaceState({}, '', `${productUrl}?variant=${encodeURIComponent(variantId)}`);
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('SeoulDepot could not update the selected variant price.', error);
          }
        } finally {
          if (currentRequest === requestSequence) {
            priceDestination.removeAttribute('aria-busy');
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
